<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Downloads</h2>
  </div>
</nz-card>

<nz-empty class="mt-10" *ngIf="data.length === 0"></nz-empty>

<nz-card class="!my-4" *ngIf="data.length > 0">
  <nz-table
    [nzData]="data"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    nzSize="middle">
    <thead>
      <tr>
        <th>Document Name</th>
        <th class="text-center">Downloads</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of data">
        <td class="font-medium text-[#441752]">{{ doc.documentName }}</td>
        <td class="text-center">
          <div class="flex justify-center gap-2 flex-wrap">
            <a
              *ngIf="getFileUrl(doc.englishFile) !== '#'"
              [href]="getFileUrl(doc.englishFile)"
              target="_blank"
              nz-button
              nzSize="small"
              nzType="primary">
              English
            </a>
            <a
              *ngIf="getFileUrl(doc.sinhalaFile) !== '#'"
              [href]="getFileUrl(doc.sinhalaFile)"
              target="_blank"
              nz-button
              nzSize="small"
              nzType="primary">
              Sinhala
            </a>
            <a
              *ngIf="getFileUrl(doc.tamilFile) !== '#'"
              [href]="getFileUrl(doc.tamilFile)"
              target="_blank"
              nz-button
              nzSize="small"
              nzType="primary">
              Tamil
            </a>
            <span
              *ngIf="!hasAnyFile(doc)"
              class="text-gray-400 text-sm">
              No files available
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<div class="mt-4 flex justify-end" *ngIf="data.length > 0">
  <nz-pagination
    class="mt-8"
    (nzPageIndexChange)="onCurrentPageDataChange($event)"
    [nzPageIndex]="currentPage"
    [nzTotal]="totalDocs"
    [nzPageSize]="pageSize"></nz-pagination>
</div>




